import styled, { css } from 'styled-components';
import { ChatCard, FlexLayout } from '@gv/triage-components';

import { ChatHeaderProps } from './types';

export const Card = styled(ChatCard)<Pick<ChatHeaderProps, 'isDetails'>>`
  ${({ isDetails }) =>
    isDetails &&
    css`
      padding: 0 0 24px;
      margin: 0 16px;
    `}
`;

export const ButtonsContainer = styled(FlexLayout)`
  flex-shrink: 0;
  flex-wrap: nowrap;
  align-items: center;

  /* Prevent buttons from shrinking and ensure they display fully */
  & > * {
    flex-shrink: 0;
    white-space: nowrap;
  }

  /* Ensure buttons have enough space for text */
  & button {
    min-width: fit-content;
  }
`;
